class CmsDataProvider {
    private data: Record<string, any>;
    constructor() {
        this.data = (window as any).__CMS_DATA || {};
    }
    get<T>(id: string): T {
        const data = this.data[id];
        if (!data) {
            throw new TypeError('no data available');
        }
        return data;
    }
}
export default new CmsDataProvider();